module.exports = __webpack_public_path__ + "4d264f4a6e323daae76bc3ea288c36e4.pdf";